import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../cmsConfig';
import { Profession } from '../../types/Profession';
import { ProfessionListViewModel } from '../../types/Guidance/ProfessionListViewModel';
export interface ReactConfig {
  applicationInsightsConnectionString: string;
}

export const professionApi = createApi({
  reducerPath: 'professionApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${cmsApiConfig.url}/profession`,
    headers: {
      'X-CSRF': '1',
    },
    credentials: 'include',
  }),
  tagTypes: ['Professions', 'FullProfessions'],
  endpoints: (builder) => ({
    getProfessions: builder.query<Profession[], void>({
      query: () => ({
        url: `/professions`,
      }),
      providesTags: ['Professions'],
    }),
    getFullProfessions: builder.query<ProfessionListViewModel[], void>({
      query: () => ({
        url: `/fullProfessions`,
      }),
      providesTags: ['FullProfessions'],
    }),
  }),
});

export const {
  useGetProfessionsQuery,
  useLazyGetProfessionsQuery,
  useGetFullProfessionsQuery,
  useLazyGetFullProfessionsQuery,
} = professionApi;
